module.exports = __webpack_public_path__ + "img/map-flower.62774ca4.jpg";